import "./SeatSelectList.scss"

import { Search } from "@skylead/component-library"
import React, { useCallback, useEffect, useRef } from "react"
import { useDispatch } from "react-redux"

import { updateFormField } from "../../../redux/actions"
import { useGlobalTranslation } from "../../../utils/hook"
import LangText from "../../atoms/LangText"
import AccountStatusItemList from "../../organisms/AccountStatusItemList"

const SeatSelectList = ({
  submitSearchAccounts,
  seatSearch,
  setSeatSearch,
  teamAccountsSumCount,
  setIsSeatSelectOpen,
  setTooltip,
  closeTooltip,
}) => {
  const dispatch = useDispatch()
  const { tt } = useGlobalTranslation()
  const menuRef = useRef(null) // Reference to the seat select menu

  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsSeatSelectOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [menuRef])

  const updateFormFieldAction = useCallback(
    (field, value) => dispatch(updateFormField(field, value)),
    [dispatch],
  )

  return (
    <div className="seat-select-custom-menu-wrapper" ref={menuRef}>
      <div className="seats">
        <div className="heading">
          <h3>
            <LangText langKey="seats" />
          </h3>
        </div>
        <Search
          placeholder={tt("seat.select.list.search-seats.placeholder")}
          field="search-account-switcher-list"
          onEnter={submitSearchAccounts}
          value={seatSearch}
          onChange={setSeatSearch}
          updateFormField={updateFormFieldAction}
        />
        <AccountStatusItemList
          isHeaderMenu
          small
          filter=""
          accountCount={teamAccountsSumCount}
          setTooltip={setTooltip}
          closeTooltip={closeTooltip}
        />
      </div>
    </div>
  )
}

export default SeatSelectList
